//
// AGNES - Technical Support Web
//
// WarrantyContracCreateController.js
//
// Copyright (c) 2015 Toyota Central Europe - Czech s.r.o.
//
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without
// restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the
// Software is furnished to do so, subject to the following
// conditions:
//
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
// OTHER DEALINGS IN THE SOFTWARE.
//

angular.module("Agnes")
    .controller("WarrantyContractCreateController", [
        "$scope", "$sessionStorage", "$http", "$activity", "$location", "$user", "$oidc", "$q",
        function ($scope, $sessionStorage, $http, $activity, $location, user, oidc, $q
        ) {
            $scope.ZERO_MILEAGE_CONST = 5;
            $scope.ADD_DAYS_FROM_ACTUAL_DATE = 6;
            $scope.CAR_NOT_FOUND = "CarNotFound";
            $scope.CAR_NOT_SOLD = "CarNotSold";
            $scope.PRODUCTS_NOT_FOUND = 'ProductsNotFound';
            $scope.HAND_OVER_DATE_MISSING = 'HandOverDateMissing';
            $scope.START_OF_WARRANTY = "StartOfWarranty";
            $scope.HAND_OVER_TODAY = "HandOverToday";

            // Storage
            $scope.$storage = $sessionStorage.$default({
                warrantyContractCreate: {
                    searchVin: null,
                }
            });

            $scope.errors = [];
            $scope.carProducts = {};
            $scope.carHistory = {};

            $scope.searching = false;

            $scope.policySoldDate = new Date();

            // Repairer
            $scope.$watch("$storage.repairer", function (newValue, oldValue) {
                if (!angular.isUndefinedNullOrEmpty(newValue) && newValue.id !== -1 && newValue.id !== oldValue.id) {
                    $scope.refresh();
                }
            });

            // Date pickers

            $scope.todayDate = new Date();

            $scope.createDateWithDaysAdded = function (date, daysAdded) {
                var tempDate = new Date(date);
                tempDate.setDate(tempDate.getDate() + daysAdded);
                return tempDate;
            }

            $scope.dateWarrantyStartOptions = {
                minDate: $scope.todayDate,
                maxDate: $scope.createDateWithDaysAdded($scope.todayDate, $scope.ADD_DAYS_FROM_ACTUAL_DATE),
                startingDay: 1
            };

            $scope.fromOpen = function () {
                $scope.popupDateFrom.opened = true;
            };
            $scope.popupDateFrom = {
                opened: false
            };

            $scope.policySoldOpen = function () {
                $scope.popupPolicySold.opened = true;
            };
            $scope.popupPolicySold = {
                opened: false
            };
            $scope.deliveryDateOpen = function () {
                $scope.popupDeliveryDate.opened = true;
            };
            $scope.popupDeliveryDate = {
                opened: false
            };

            /******************   Car search ***/

            $scope.showCarInfo = function () {
                return $scope.carDetail !== null && $scope.carHistory.isStartOfWarranty;
            }

            $scope.showCarProducts = function () {
                return $scope.showCarInfo() && $scope.carProducts.data;
            }

            $scope.nullValues = function () {
                $scope.errors = [];
                $scope.carDetail = {};
                $scope.carHistory = {};
                $scope.carProducts = {};

                $scope.contracts = null;
                $scope.tmeContracts = null;
            }

            $scope.search = function () {
                $scope.nullValues();

                $scope.searchVin($scope.$storage.warrantyContractCreate.searchVin);
            }

            $scope.getItemStripeClass = function (item) {
                var date = new Date();
                var dateFrom = new Date(item.dateFrom);
                var dateTo = new Date(item.dateTo);
                if (dateFrom <= date && dateTo >= date && item.warrantyKm >= $scope.carHistory.purchaseOdo)
                    return "bg-green";
                return "bg-red";
            }

            $scope.getTmeItemStripeClass = function (item) {
                var date = new Date();
                var coverStartDate = new Date(item.coverStartDate);
                var coverEndDate = new Date(item.coverEndDate);

                if (
                    coverStartDate <= date && coverEndDate >= date
                    && item.coverStartCounterMileage <= $scope.carHistory.purchaseOdo && item.coverCounterMileage >= $scope.carHistory.purchaseOdo
                )
                    return "bg-green";
                return "bg-red";
            }



            $scope.searchVin = function (vin) {
                $activity.start();
                $scope.searching = true;
                $http
                    .get("/api/warranty/car/" + vin, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        if (angular.isUndefinedNullOrEmpty(response.data.handOverDate)) {
                            $scope.errors.push($scope.HAND_OVER_DATE_MISSING);
                            return;
                        }

                        if (response.data.isHandOverToday) {
                            $scope.errors.push($scope.HAND_OVER_TODAY);
                            return;
                        }

                        response.data.handOverDate = new Date(response.data.handOverDate);
                        $scope.carDetail = response.data;

                        var history = searchHistory($scope.carDetail.vin);
                        var products = getContracts($scope.carDetail.vin);
                        var tmeProducts = getTmeContracts($scope.carDetail.vin)
                        return $q.all([history, products, tmeProducts]);
                    }, function (response) {
                        if (response.status === 404) {
                            $scope.errors.push($scope.CAR_NOT_FOUND);
                        }
                        else {
                            $scope.errors.push(response.status);
                        }
                        return $q.reject();
                    })
                    .then(function () {
                        $activity.finish();
                        $scope.searching = false;
                    }, function () {
                        $activity.finish();
                        $scope.searching = false;
                    });
            };

            function getContracts(vin) {
                $activity.start();
                return $http
                    .get('api/car/' + vin + '/warranty-contract', {
                        headers: {
                            Authorization: oidc.current.token_type + ' ' + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.contracts = response.data;
                    })
                    .then(function () {
                        $activity.finish();
                    }, function () {
                        $activity.finish();
                    });
            }

            function getTmeContracts(vin) {
                $activity.start();
                return $http
                    .get('api/car/' + vin + '/tme-warranty-contract', {
                        headers: {
                            Authorization: oidc.current.token_type + ' ' + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.tmeContracts = response.data;
                    })
                    .then(function () {
                        $activity.finish();
                    }, function () {
                        $activity.finish();
                    });
            }

            function searchHistory(vin) {
                if ($scope.carDetail === null) { return false; }

                $activity.start();
                return $http
                    .get("/api/warranty/car/" + vin + "/history", {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        if (response.data.length !== 0) {
                            $scope.carHistory = response.data;
                            $scope.getPurchaseOdo();

                            if ($scope.carHistory.isStartOfWarranty) {
                                $scope.searchProducts(vin, $scope.$storage.repairer.party.name, $scope.carDetail.handOverDate);
                            }
                            else {
                                $scope.errors.push($scope.CAR_NOT_SOLD);
                            }
                        }
                        else {
                            $scope.errors.push($scope.CAR_NOT_SOLD);
                        }
                    }, function (response) {
                        $scope.errors.push(response.status);
                    })
                    .then(function () {
                        $activity.finish();
                    }, function () {
                        $activity.finish();
                    });
            };

            $scope.researchProducts = function () {
                if (!$scope.carHistory.purchaseOdo || ($scope.carHistory.purchaseOdo && !Number.isInteger($scope.carHistory.purchaseOdo))) {
                    return;
                }

                $scope.vin = $scope.$storage.warrantyContractCreate.searchVin;

                $scope.errors = [];
                $scope.carProducts = {};

                if ($scope.carHistory.isStartOfWarranty) {
                    $scope.searchProducts($scope.vin, $scope.$storage.repairer.party.name, $scope.carDetail.handOverDate);
                }
                else {
                    $scope.errors.push($scope.CAR_NOT_SOLD);
                }
            }

            $scope.searchProducts = function (vin, retailerCode, carAge) {
                $activity.start();
                $http
                    .get("/api/warranty/car/" + vin + "/products", {
                        params: {
                            retailerCode: retailerCode,
                            deliveryDate: carAge.toUTCString(),
                            mileage: $scope.carHistory.purchaseOdo
                        },
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        if (response.data.length !== 0) {
                            response.data.forEach(function (val) {
                                val.validFrom = new Date(val.validFrom);
                                val.validTo = new Date(val.validTo);
                            });

                            $scope.carProducts = {
                                data: response.data,
                                selectedProduct: response.data[0]
                            };
                        }
                        else {
                            $scope.errors.push($scope.PRODUCTS_NOT_FOUND);
                        }
                    }, function (response) {
                        $scope.errors.push(response.status);
                    })
                    .then(function () {
                        $activity.finish();
                    }, function () {
                        $activity.finish();
                    });
            };

            $scope.createWarranty = function () {
                $activity.start();
                var data = {
                    Vin: $scope.carDetail.vin,
                    WarrantyProductId: $scope.carProducts.selectedProduct.id,
                    RetailerCode: $scope.$storage.repairer.party.name,
                    DateFrom: $scope.carProducts.selectedProduct.validFrom,
                    DateTo: $scope.carProducts.selectedProduct.validTo,
                    CarDeliveryDate: $scope.carDetail.handOverDate,
                    Mileage: $scope.carHistory.purchaseOdo,
                    IssuedByPartyId: $scope.$storage.repairer.party.wellId,
                    UserLoginName: user.loginName,
                    FuelTypeCode: $scope.carDetail.fuelTypeCode,
                    EngineCapacity: $scope.carDetail.engineCapacity
                };
                $http
                    .post("/api/warranty/car/" + $scope.carDetail.vin + "/create", data, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $location.path("/warranty-contract/browse").search({ vin: $scope.vin });;
                    }, function (response) {
                        $scope.errors.push(response.status);
                    })
                    .then(function () {
                        $activity.finish();
                    }, function () {
                        $activity.finish();
                    });
            }

            $scope.getPurchaseOdo = function () {
                if ($scope.carHistory.lastMileage === 0) {
                    $scope.carHistory.purchaseOdo = $scope.ZERO_MILEAGE_CONST;
                }
                else {
                    $scope.carHistory.purchaseOdo = $scope.carHistory.lastMileage;
                }
            };

            $scope.productSelected = function () {
                return ($scope.carProducts !== null && $scope.carProducts.selectedProduct !== null);
            }

            $scope.refresh = function () {
                $scope.search();
            };
        }
    ]);